import React, { useState } from "react";
import { useYooKassa } from "./useYooKassa";
import styles from "./Payment.module.scss";
import { useServiceWorkflowStore } from "@/shared/stores/serviceWorkflowStore";

interface YooKassaWidgetProps {
  method: string | null;
  tariffId: number | null;
  promocode: string | null;
  email: string | null;
  onError: (message: string) => void;
  onSuccess: () => void;
}

export const YooKassaWidget: React.FC<YooKassaWidgetProps> = ({
  method,
  tariffId,
  promocode,
  email,
  onError,
  onSuccess,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const { pId } = useServiceWorkflowStore();

  useYooKassa(
    method,
    tariffId,
    promocode,
    email,
    pId ?? null,
    () => setIsLoading(false),
    onError,
    onSuccess,
  );

  return (
    <div className={styles.paymentFormContainer}>
      {isLoading && (
        <div className={styles.paymentLoader}>
          <div className={styles.spinner}></div>
          <p>Загрузка формы оплаты...</p>
        </div>
      )}
      <div
        id="payment-form"
        style={{ display: isLoading ? "none" : "block" }}
      ></div>
    </div>
  );
};
